import React, { useEffect, useState } from "react";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import OtpForm from "./OtpForm";
import EmailVerification from "./EmailVerification";
import { LoginPageHooks } from "./hooks/LoginHooks";
import { withAuthenticationRequired } from "@auth0/auth0-react";

const LoginPage = () => {
  const { currentForm, setCurrentForm, navigate, isAuthenticated } = LoginPageHooks();
  // useEffect(() => {
  //     const token = localStorage.getItem('token');
  //     if (token !== null) {
  //         navigate('/dashboard')
  //     }
  // }, [])


  useEffect(() => {
    localStorage.removeItem("email");
  }, []);

  useEffect(() => {
    if (currentForm === "login" && isAuthenticated) {
      navigate("/validate-user");
    }
  }, [currentForm, isAuthenticated, navigate]);

  return (
    <div className="bg-image-class-content flex bg-slate-800 h-full w-full">
      <div className="h-[100vh] w-1/2"></div>
      <div className="flex justify-center items-center h-[100vh] w-1/2">
        {/* {currentForm === "login" && <LoginForm setCurrentForm={setCurrentForm} />} */}
        {currentForm === "signup" && <SignupForm setCurrentForm={setCurrentForm} />}
        {currentForm === "validate" && <EmailVerification setCurrentForm={setCurrentForm} />}
        {currentForm === "forgotpassword" && <ForgotPasswordForm setCurrentForm={setCurrentForm} />}
        {currentForm === "otp" && <OtpForm setCurrentForm={setCurrentForm} />}
      </div>
    </div>
  );
};

export default withAuthenticationRequired(LoginPage);
// components/universal/ProtectedHome.jsx
// import React from "react";
// import { useSelector } from "react-redux";
// import Dashboard from "../../screens/Dashboard/Dashboard";
// import Addfield from "../../screens/AddFields/Addfield";

// const ProtectedHome = () => {
//   const { userInfo } = useSelector((state) => state.user);

//   // ✅ Show fallback until userInfo is available
//   if (!userInfo) {
//     return (
//       <div className="flex items-center justify-center h-screen text-xl font-bold">
//         Loading...
//       </div>
//     );
//   }

//   // ✅ Role based rendering
//   return userInfo.roleCode === "17dwer8" ? <Addfield /> : <Dashboard />;
// };

// export default ProtectedHome;
